import { v4 as uuidv4 } from 'uuid'

export default {
  methods: {
    getUniqueId() {
      return uuidv4()
    },
    isBright(hex) {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      let rgb = result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
      } : null

      let r = 0.2126 * rgb['r']
      let g = 0.7152 * rgb['g']
      let b = 0.0722 * rgb['b']

      return (r + g + b > 186)
    },
    formatObject(object, type, fallback) {
      if (undefined !== object && null !== object) {
        if (Array.isArray(object)) {
          if (object.length > 0) {
            switch (type) {
              case 'exponent':
                return `${object['firstName']} ${object['lastName']}`
              case 'product':
                return object['name']
              case 'sizes':
                return object.reduce((acc, cur) => {
                  return `${acc} ${cur.name},`
                }, '')
            }
          }
        } else {
          if (Object.keys(object).length > 0) {
            switch (type) {
              case 'exponent':
                return `${object.firstName} ${object.lastName}`
              case 'product':
                return object.name
              case 'sizes':
                const string = ''
                for (const key in object) {
                  string += `${object[key].name},`
                }
                return string
            }
          }
        }
      }

      return fallback
    },
    first(array, n) {
      if (array == null)
        return void 0
      if (n == null)
        return array[0]
      if (n < 0)
        return []
      return array.slice(0, n)
    },
    firstObject(object) {
      return Object.entries(object)[0][1]
    }
  },
}